__turbopack_context__.v({
  "image": "TM3ooa_image",
  "root": "TM3ooa_root",
  "text": "TM3ooa_text",
});
